module.exports = __webpack_public_path__ + "static/0013-155010170abc97578e8b996cf79ff806.png";